// extracted by mini-css-extract-plugin
export default {"without-scrollbar":"carousel_without-scrollbar__oYl1d"};